import React from "react";
import {Card, CardContent} from "@/components/ui/card";
import {Module} from "./ModuleList";
import WorkflowDiagram from "./WorkflowDiagram";

interface WorkflowMermaidDiagramProps {
    modules: Module[];
}

const WorkflowMermaidDiagram = ({modules}: WorkflowMermaidDiagramProps) => {
    return (
        <Card className="w-full h-full apple-card border-none">
            <CardContent className="p-3 h-full">

                    <WorkflowDiagram modules={modules}/>

            </CardContent>
        </Card>
    );
};

export default WorkflowMermaidDiagram;
